import {
    CONTENT_QUERY,
    CONTENT_UPDATE,
    CONTENT_UPDATE_FORM_CUSTOM_FIELD_VALIDITY,
    CONTENT_UPDATE_FORM,
    CONTENT_FORM_SUBMIT_QUERY,
    CONTENT_REMOVE_FORM_FIELD_ERROR,
    CONTENT_REMOVE_CONSENT_ERROR,
} from "./actionTypes";
import apiService from "../../services/apiService";
import { pushFormSubmission } from "../../services/datalayerService.js";

function content_notify() {
    return {
        type: CONTENT_QUERY,
    };
}

function updateContent(content) {
    return {
        type: CONTENT_UPDATE,
        content,
    };
}

function form_notify() {
    return {
        type: CONTENT_FORM_SUBMIT_QUERY,
    };
}

function updateFormResults(results) {
    return {
        type: CONTENT_UPDATE_FORM,
        results,
    };
}

export function updateFormFieldCustomFieldValidity(index, validity) {
    return {
        type: CONTENT_UPDATE_FORM_CUSTOM_FIELD_VALIDITY,
        index: index,
        validity: validity,
    };
}

export function removeFormFieldError(index) {
    return {
        type: CONTENT_REMOVE_FORM_FIELD_ERROR,
        index,
    };
}

export function removeConsentError() {
    return {
        type: CONTENT_REMOVE_CONSENT_ERROR,
    };
}

export function formSubmission(data) {
    return function (dispatch) {
        dispatch(form_notify());
        return apiService
            .submitForm(data)
            .then((response) => {
                //we need to update the form response now
                //add in the google submission
                if (response.data.success == true) {
                    pushFormSubmission();
                }

                dispatch(updateFormResults(response.data));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}

export function queryContent() {
    return function (dispatch) {
        dispatch(content_notify);
        return apiService
            .getContent()
            .then((response) => {
                if (response.data.success === true)
                    dispatch(updateContent(response.data.data));
            })
            .catch((err) => {
                console.error(err);
            });
    };
}
